import { useState, useEffect, useRef } from 'react';
import { IoChevronDown, IoChevronUp, IoClose } from 'react-icons/io5';

const SelectMultiSearch = ({
  label = 'Select Options',
  options = [],
  value = [],
  onChange = () => { },
  onRemove = () => { },
  onSearch,
  error = false,
  placeholder = '',
  disabled = false
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const toggleOption = (optionValue) => {
    // if (disabled) return;

    let newValue;
    if (value.includes(optionValue)) {
      newValue = value.filter((val) => val !== optionValue);
      onRemove(optionValue); // ✅ call onRemove when unselecting
    } else {
      newValue = [...value, optionValue];
    }
    onChange(newValue);
  };

  const clearSelection = (e) => {
    e.stopPropagation();
    value.forEach((val) => onRemove(val));
    onChange([]);
  };

  const handleSearchChange = (term) => {
    setSearchTerm(term);
    if (onSearch) onSearch(term);
  };

  const filteredOptions = options
    .filter((opt) =>
      opt.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (opt.labeltwo && opt.labeltwo.toString().includes(searchTerm))
    )
    .sort((a, b) => {
      const aSelected = value.includes(a.value);
      const bSelected = value.includes(b.value);
      return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
    });


  const displayLabel = value.length === 0 ? '' : `${value.length} selected`;
  const shouldFloat = dropdownOpen || value.length > 0;

  return (
    <div className="form-floating mb-2" ref={containerRef} style={{ position: 'relative', width: '100%' }}>
      <div
        className={`${error ? 'errorborder' : ''} form-control p-0 px-2 d-flex justify-content-between align-items-center ${disabled ? 'disabledil' : ''}`}
        // onClick={() => !disabled && setDropdownOpen(!dropdownOpen)}
        onClick={() => setDropdownOpen(!dropdownOpen)}

        style={{
          // cursor: disabled ? 'not-allowed' : 'pointer',

          cursor: 'pointer',
          fontSize: '0.8rem',
          height: '30px',
          backgroundColor: disabled ? '#white' : 'white',
        }}
      >
        <span style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          {displayLabel}
        </span>
        <div className="d-flex align-items-center">
          {value.length > 0 && !disabled && (
            <IoClose
              size={14}
              className="me-1"
              onClick={clearSelection}
              style={{ color: '#6c757d' }}
            />
          )}

          {dropdownOpen ? <IoChevronUp size={14} /> : <IoChevronDown size={14} />}
        </div>
      </div>
   
      <label
        style={{
          fontSize: '0.75rem',
          top: shouldFloat ? '0px' : '50%',
          transform: shouldFloat ? 'scale(0.85) translateY(-1.3rem)' : 'translateY(-50%)',
          transition: '0.2s ease',
          backgroundColor:shouldFloat ? 'white' : 'transparent',
          padding: '0 4px',
          left: '10px',
          zIndex: 1,
          position: 'absolute',
          pointerEvents: 'none',
          color: '#6c757d'
        }}
      >
        {label}
      </label>

      {dropdownOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #ced4da',
            borderRadius: '4px',
            maxHeight: '200px',
            overflowY: 'auto',
            zIndex: 999,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
        >
          {onSearch && (
            <div style={{ padding: 6, borderBottom: '1px solid #eee', position: 'sticky', top: 0, backgroundColor: 'white' }}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => handleSearchChange(e.target.value)}
                placeholder={`Search ${label}`}
                style={{
                  width: '100%',
                  padding: '4px 8px',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  fontSize: '0.8rem',
                  outline: 'none',
                  height: '28px'
                }}
                onClick={(e) => e.stopPropagation()}
                autoFocus
              />
            </div>
          )}

          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.value}
                style={{
                  padding: '6px 12px',
                  fontSize: '0.8rem',
                   cursor: disabled ? 'not-allowed' : 'pointer',
                  backgroundColor: value.includes(option.value) ? '#f8f9fa' : 'white',
                  borderLeft: value.includes(option.value) ? '3px solid #e69500' : '3px solid transparent',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onClick={!disabled ? () => toggleOption(option.value) : undefined}
              >
                <input
                  type="checkbox"
                  checked={value.includes(option.value)}
                  readOnly
                  style={{
                    marginRight: '8px',
                    cursor: 'pointer',
                    accentColor: value.includes(option.value) ? '#391f84' : '#6c757d'
                  }}
                />
                {option.label} {option.labeltwo && `| ${option.labeltwo}`}
              </div>
            ))
          ) : (
            <div style={{ padding: '10px', color: '#6c757d', textAlign: 'center' }}>
              No options found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectMultiSearch;
